import { Injectable } from "@angular/core";
import { ClientsModel } from "@modules/api/clients-model.generated";
import { GetClientsService } from "@modules/api/get-clients.service.generated";
import { CurrentEnvironmentService } from '@modules/common/services/current-environment.service';
import { UserSessionService } from "@modules/common/services/user-session.service";
import { merge, Observable, ReplaySubject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class CachedCaseListService {
    private _subject = new ReplaySubject<ClientsModel[]>(1);

    constructor(
        getClientsService: GetClientsService,
        userSessionService: UserSessionService,
        currentEnvironmentService: CurrentEnvironmentService
    ) {
        merge(
            userSessionService.userSessionChanged(),
            currentEnvironmentService.environmentChanged
        ).subscribe(() => {
            const userSession = userSessionService.getUserSession();
            if (userSession) {
                if (userSession.restrictedToCase) {
                    this._subject.next([{
                        clientCode: userSession.restrictedToCase.code,
                        clientName: userSession.restrictedToCase.name
                    }]);
                } else {
                    getClientsService.getClients().subscribe(result => {
                        this._subject.next(result);
                    });
                }
            }
        });
    }

    public get cachedCaseListChanged(): Observable<ClientsModel[]> {
        return this._subject;
    }
}
